/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ChangePasswordRequest
 */
export interface ChangePasswordRequest {
  /**
   * Текущий пароль пользователя
   * @type {string}
   * @memberof ChangePasswordRequest
   */
  currentPassword: string
  /**
   * Новый пароль
   * @type {string}
   * @memberof ChangePasswordRequest
   */
  newPassword: string
  /**
   * Подтверждение нового пароля (должно совпадать с newPassword)
   * @type {string}
   * @memberof ChangePasswordRequest
   */
  newPasswordConfirmation: string
}

/**
 * Check if a given object implements the ChangePasswordRequest interface.
 */
export function instanceOfChangePasswordRequest(
  value: object
): value is ChangePasswordRequest {
  if (!('currentPassword' in value) || value['currentPassword'] === undefined)
    return false
  if (!('newPassword' in value) || value['newPassword'] === undefined)
    return false
  if (
    !('newPasswordConfirmation' in value) ||
    value['newPasswordConfirmation'] === undefined
  )
    return false
  return true
}

export function ChangePasswordRequestFromJSON(
  json: any
): ChangePasswordRequest {
  return ChangePasswordRequestFromJSONTyped(json, false)
}

export function ChangePasswordRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ChangePasswordRequest {
  if (json == null) {
    return json
  }
  return {
    currentPassword: json['currentPassword'],
    newPassword: json['newPassword'],
    newPasswordConfirmation: json['newPasswordConfirmation'],
  }
}

export function ChangePasswordRequestToJSON(
  value?: ChangePasswordRequest | null
): any {
  if (value == null) {
    return value
  }
  return {
    currentPassword: value['currentPassword'],
    newPassword: value['newPassword'],
    newPasswordConfirmation: value['newPasswordConfirmation'],
  }
}
